import { render, staticRenderFns } from "./RejectDlg.vue?vue&type=template&id=66c488d0"
import script from "./RejectDlg.vue?vue&type=script&lang=js"
export * from "./RejectDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports